module.exports = __webpack_public_path__ + "media/bootstrap-icons/layer-forward-ba6ec198.svg";